module.exports = __webpack_public_path__ + "img/msg.5d80fc99.png";